<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>search-circle</title>
    <path
      d="M15.238,14.146a.25.25,0,0,1-.03-.316,5.05,5.05,0,1,0-1.381,1.381.25.25,0,0,1,.316.03l2.535,2.534a.784.784,0,0,0,1.095,0,.774.774,0,0,0,0-1.094Zm-4.206.373a3.484,3.484,0,1,1,3.484-3.484A3.488,3.488,0,0,1,11.032,14.519Z"
    />
    <path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z" />
  </svg>
</template>
